import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	var obj = {

		headData: [{
				title: "标题",
				prop: "policyTitle",
				width: 230,
				custom: true,
			},
			{
				title: "发文字号",
				prop: "policyNum",
				custom: true,
				width: "150",
			},
			{
				title: "相关文档",
				prop: "policyFile",
				custom: true,
				width: "70"
			},
			{
				title: "是否失效",
				prop: "isValid",
				width: "70",
				custom: true,
				headcustom: true,
				headprop: 'isValid_headprop',
			},
			{
				title: "政策类型",
				prop: "policyType",
				width: "70",
				custom: true
			},
			// {
			// 	title: "相关税种",
			// 	prop: "xianggxz",
			// 	width: "100",
			// 	custom: true
			// },
			{
				title: "大类",
				prop: "tagNames",
				width: "100",
				custom: true
			},{
				title: "备注",
				prop: "remark",
				width: "100",
			},
			{
				title: "发文日期",
				prop: "fabTime",
				width: 90,
				custom: true
			},
			{
				title: "施行日期",
				prop: "implementTime",
				width: 90,
				custom: true
			},
			{
				title: "发文机构",
				prop: "fbdanw",
				width: 160,
				custom: true,

			},{
				title: "重要程度",
				prop: "zhongycd",
				width: 160,
				custom: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "100",
				custom: true,
				fixed: "right"
			},

		],
		seezcformlist: [{
				prop: "policyTitle",
				label: "标题",
				type: "input",
				istosee: true
			},
			{
				prop: "policyNum",
				label: "发文字号",
				type: "input",
				istosee: true
			},
			{
				prop: "isValid",
				label: "是否失效",
				type: "radio",
				radioval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "2"
					},{
						label: "部分",
						value: "3"
					}
				],
				istosee: true
			},
			{
				prop: "xianggxz",
				label: "相关税种",
				type: "radio",
				istosee: true,
				radioval: comMapping.$xgsz
			},
			{
				prop: "policyType",
				label: "政策类型",
				type: "radio",
				istosee: true,
				radioval: comMapping.$sszskzclx,
			},
			{
				prop: "tagIds",
				label: "大类",
				type: "radio",
				istosee: true,
				width: "220px",
				slot:true,
			},
			{
				prop: "zhongycd",
				label: "重要程度",
				type: "radio",
				width: "220px",
				istosee: true,
				radioval:[
					{
						value:'1',
						label:'一般'
					},{
						value:'2',
						label:'重要'
					},
				],
			},
			{
				prop: "fabTime",
				label: "发文日期",
				type: "input",
				istosee: true
			},
			{
				prop: "implementTime",
				label: "施行日期",
				type: "input",
				istosee: true
			},
			{
				prop: "fbDanw",
				label: "发文机构",
				type: "input",
				istosee: true
			},{
				prop: "remark",
				label: "备注",
				type: "input",
				istosee: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		searchlist:[
      {
				prop: "policyTitle",
				label: "标题",
				type: "input",
				width: "220px",
			},
			{
				prop: "policyNum",
				label: "发文字号",
				type: "input",
			},
			{
				prop: "policyDesc",
				label: "正文内容",
				type: "input",
				width: "220px",
			},	{
				prop: "isValid",
				label: "是否失效",
				type: "select",
				selectval: [
					{
						value:'1',
						label:'是'
					},{
						value:'2',
						label:'否'
					},{
						value:'3',
						label:'部分'
					},
				],
				width: "220px",
			},{
				prop: "policyType",
				label: "政策类型",
				type: "select",
				width: "220px",
				selectval: comMapping.$sszskzclx,
			},{
				prop: "tagId",
				label: "大类",
				type: "select",
				width: "220px",
				selectval: [],
			},	{
				prop: "fbDanw",
				label: "发文机构",
				type: "input",
				width: "220px",
			},	
			{
				prop: "xianggxzs",
				label: "相关税种",
				type: "selectmore",
				width: "220px",
				selectval: comMapping.$xgsz
			},{
				prop: "remark",
				label: "备注",
				type: "input",
				width: "220px",
			},
			{
				prop: "fabTime",
				label: "发文日期",
				type: "date",
				width: "220px",
				valueformat:'yyyy-MM-dd'
			},
			{
				prop: "implementTime",
				label: "施行日期",
				type: "date",
				width: "220px",
				valueformat:'yyyy-MM-dd'
			},
    ],
		searchdata: {
			policyTitle: "",
			policyNum: "",
			policyDesc: "",
			isValid: "",
			policyType: "",
			tagIds: [],
			fbDanw: "",
			xianggxzs: "",
			fabTime: "",
			implementTime: "",
			remark:'',
			zhongycd:'',
		},
		seezcformdata: {}
	}
	return obj
}
